export const CHART_COLORS = {
  primary: '#1F2937',
  positive: '#059669',
  negative: '#DC2626',
  info: '#2563EB',
  warning: '#D97706',
  muted: '#9CA3AF',
  border: '#E5E7EB',
  bgRoot: '#F8F9FB',
};

export const SERIES_PALETTE = [
  '#2563EB', '#059669', '#D97706', '#DC2626', '#7C3AED',
  '#0891B2', '#CA8A04', '#BE185D', '#4F46E5', '#15803D',
  '#6366F1',
];

export const CHART_DEFAULTS = {
  margin: { top: 10, right: 20, bottom: 5, left: 10 },
  fontSize: 11,
  fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
  gridStroke: '#F3F4F6',
};

export const getDhBarColor = (dh) => {
  if (dh <= 5) return '#059669';
  if (dh <= 10) return '#22c55e';
  if (dh <= 15) return '#D97706';
  if (dh <= 25) return '#f97316';
  return '#DC2626';
};
